import React from "react";
import Helmet from "react-helmet";

import { Col, Row, Menu, Collapse } from "antd";

import Header from "@components/header";
import Footer from "@components/footer";
import { useI18n } from "@src/i18n";

import TextCenterBanner from "../../components/textCenterBanner";

import * as styles from "./index.module.scss";

import pcImg from "@src/images/feature/Rectangle4386.png";
import phoneImg from "@src/images/feature/Rectangle4387.png";

// import pcImg from "@src/images/aboutMe/飞书20210917-160432.png";
// import phoneImg from "@src/images/aboutMe/飞书20210917-160405.png";

import headerBg from "@src/images/feature/飞书20210914-143446.png";

//图标引入
import ThemeIcon1 from "@src/images/feature/列表视图_list-view 1.png";
import ThemeIcon2 from "@src/images/feature/图片_picture 1.png";
import ThemeIcon3 from "@src/images/feature/信息_message 1.png";
import ThemeIcon4 from "@src/images/feature/双卡片_card-two 1.png";
import ThemeIcon5 from "@src/images/feature/应用_application-two 1.png";
import ThemeIcon6 from "@src/images/feature/图形设计_graphic-design 1.png";

import ConstructIcon1 from "@src/images/feature/翻译_translate 1.png";
import ConstructIcon2 from "@src/images/feature/分类管理_category-management 1.png";
import ConstructIcon3 from "@src/images/feature/设置_setting-one 1.png";
import ConstructIcon4 from "@src/images/feature/列表_list 1.png";
import ConstructIcon5 from "@src/images/feature/商品_commodity 1.png";
import ConstructIcon6 from "@src/images/feature/美化_optimize 1.png";

import ManagementIcon1 from "@src/images/feature/人员_people 1.png";
import ManagementIcon2 from "@src/images/feature/应用_application 1.png";
import ManagementIcon3 from "@src/images/feature/订单_order 1.png";
import ManagementIcon4 from "@src/images/feature/站点加速_whole-site-accelerator 1.png";

import TransformIcon1 from "@src/images/feature/Group.png";
import TransformIcon2 from "@src/images/feature/闪付_flash-payment 1.png";
import TransformIcon3 from "@src/images/feature/优惠券_coupon 1.png";
import TransformIcon4 from "@src/images/feature/脸书_facebook 1.png";

import MobileIcon1 from "@src/images/feature/数据图_chart-pie-one 1.png";
import MobileIcon2 from "@src/images/feature/文件夹-关_folder-close 1.png";
import MobileIcon3 from "@src/images/feature/编辑文件1_file-editing-one (1) 1.png";
import MobileIcon4 from "@src/images/feature/同步_sync 1.png";
import MobileIcon5 from "@src/images/feature/自选_optional 1.png";
import MobileIcon6 from "@src/images/feature/笔记_notes 1.png";

const iconGroups = [
  [ThemeIcon1, ThemeIcon2, ThemeIcon3, ThemeIcon4, ThemeIcon5, ThemeIcon6],
  [ConstructIcon1, ConstructIcon2, ConstructIcon3, ConstructIcon4, ConstructIcon5, ConstructIcon6],
  [ManagementIcon1, ManagementIcon2, ManagementIcon3, ManagementIcon4],
  [TransformIcon1, TransformIcon2, TransformIcon3, TransformIcon4],
  [MobileIcon1, MobileIcon2, MobileIcon3, MobileIcon4, MobileIcon5, MobileIcon6],
  [],
];

const FeaturePage = () => {
  const { t } = useI18n();
  const ListData = t("featurePage.sections").map((item, index) => ({
    ...item,
    details: item.details.map((detail, detailIndex) => ({
      ...detail,
      leftIcon: iconGroups[index][detailIndex],
    })),
  }));
  const tableData = t("featurePage.tableData");

  return (
    <div className={styles.featuresPage}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("featurePage.title")}</title>
      </Helmet>
      <Header />
      <TextCenterBanner pcImg={pcImg} phoneImg={phoneImg} text={t("featurePage.banner")} />

      <Row>
        {/* pc端 */}
        <Col xs={0} sm={0} md={24}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <Menu
              mode="horizontal"
              // defaultSelectedKeys={["0"]}
              style={{
                height: "96px",
                lineHeight: "96px",
                borderBottom: "none",
                justifyContent: "space-between",
              }}
            >
              {ListData.map((item, index) => {
                return (
                  <Menu.Item key={item.title} style={{ padding: "0 50px" }}>
                    <a href={`#${index}`} style={{ fontSize: "18px" }}>
                      {item.title}
                    </a>
                  </Menu.Item>
                );
              })}
            </Menu>
            <div className={styles.listGroup}>
              {/* 第一个主题有点不同 */}
              <div className={styles.listItem} key={ListData[0].title} id={0}>
                <div className={styles.itemHeader}>
                  <img
                    src={headerBg}
                    alt="headerBg"
                    style={{ width: "100%" }}
                  />
                  <span>{ListData[0].title}</span>
                </div>
                <div className={styles.content}>
                  <div className={styles.special1}>
                    {t("featurePage.vogueImagination")}
                  </div>
                  {ListData[0].details
                    .filter(
                      (_, index) => index < ListData[0].details.length - 1
                    )
                    .map((subitem) => {
                      return (
                        <div
                          className={styles.contentItem}
                          key={subitem.textHeader}
                        >
                          <div className={styles.imgContainer}>
                            <img src={subitem.leftIcon} alt="aa" />
                          </div>
                          <div className={styles.textContainer}>
                            <div className={styles.textHeader}>
                              {/* 个性化的图文、精选商品、视频等模块，满足各个行业需求 */}
                              {subitem.textHeader}
                            </div>
                            <div className={styles.textNormal}>
                              {/* 支持顾客名单导入导出，快速录入新老客户；支持顾客按照条件筛选查找快速定位；支持下单、退单、发货、退货、退款、确认等全流程通知；通知模板多样化个性化设置。 */}
                              {subitem.textNormal}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  <div className={styles.special1}>
                    {t("featurePage.vogueDesign")}
                  </div>
                  <div className={styles.contentItem}>
                    <div
                      className={styles.imgContainer}
                      style={{ margin: "0" }}
                    >
                      <img
                        src={
                          ListData[0].details[ListData[0].details.length - 1]
                            .leftIcon
                        }
                        alt="aa"
                      />
                    </div>
                    <div className={styles.textContainer}>
                      <div className={styles.textHeader}>
                        {
                          ListData[0].details[ListData[0].details.length - 1]
                            .textHeader
                        }
                      </div>
                      <div className={styles.textNormal}>
                        {
                          ListData[0].details[ListData[0].details.length - 1]
                            .textNormal
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {ListData.filter((_, index) => index).map((item, index) => {
                return (
                  <div
                    className={styles.listItem}
                    key={item.title}
                    id={index + 1}
                  >
                    {/* 每一个主题里面的内容 */}
                    <div className={styles.itemHeader}>
                      <img
                        src={headerBg}
                        alt="headerBg"
                        style={{ width: "100%" }}
                      />
                      <span>{item.title}</span>
                    </div>
                    <div className={styles.content}>
                      {item.details.map((subitem, subIndex) => {
                        return (
                          <div
                            className={styles.contentItem}
                            key={subitem.textHeader}
                          >
                            <div className={styles.imgContainer}>
                              <img src={subitem.leftIcon} alt="aa" />
                            </div>
                            <div className={styles.textContainer}>
                              <div className={styles.textHeader}>
                                {/* 个性化的图文、精选商品、视频等模块，满足各个行业需求 */}
                                {subitem.textHeader}
                              </div>
                              <div className={styles.textNormal}>
                                {/* 支持顾客名单导入导出，快速录入新老客户；支持顾客按照条件筛选查找快速定位；支持下单、退单、发货、退货、退款、确认等全流程通知；通知模板多样化个性化设置。 */}
                                {subitem.textNormal}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
            <table className={styles.tableContainer}>
              <thead>
                <tr>
                  <th>{t("featurePage.tableHeaders.0")}</th>
                  <th>{t("featurePage.tableHeaders.1")}</th>
                  <th className={styles.tdSpecial}>
                    <div
                      className={styles.tdInnerBox}
                      style={{ border: "none" }}
                    >
                      {t("featurePage.tableHeaders.2")}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((item) => {
                  return (
                    <tr key={item.name}>
                      <td>{item.name}</td>
                      <td>{item.intro}</td>
                      <td className={styles.tdSpecial}>
                        {item.details.map((item) => (
                          <div className={styles.tdInnerBox} key={item}>
                            {item}
                          </div>
                        ))}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Col>

        {/* 移动端 */}
        <Col xs={24} sm={24} md={0}>
          <Collapse
            // defaultActiveKey={["1"]}
            expandIconPosition="right"
            className={styles.phoneShowBox}
            style={{ marginTop: "20px", border: "none" }}
          >
            {/* 第一个照常有点不一样 */}
            <Collapse.Panel header={ListData[0].title} key={0}>
              <div className={styles.smallSpecial1}>
                {t("featurePage.vogueImagination")}
              </div>

              {ListData[0].details
                .filter((_, index) => index < ListData[0].details.length - 1)
                .map((secItem) => {
                  return (
                    <div className={styles.pannelItem} key={secItem.textHeader}>
                      <img src={secItem.leftIcon} alt="" />
                      <div className={styles.textHeader}>
                        {secItem.textHeader}
                      </div>
                      <div className={styles.textNormal}>
                        {secItem.textNormal}
                      </div>
                    </div>
                  );
                })}
              <div className={styles.smallSpecial1}>
                {t("featurePage.vogueDesign")}
              </div>
              <div className={styles.pannelItem}>
                <img
                  src={
                    ListData[0].details[ListData[0].details.length - 1].leftIcon
                  }
                  alt=""
                />
                <div className={styles.textHeader}>
                  {
                    ListData[0].details[ListData[0].details.length - 1]
                      .textHeader
                  }
                </div>
                <div className={styles.textNormal}>
                  {
                    ListData[0].details[ListData[0].details.length - 1]
                      .textNormal
                  }
                </div>
              </div>
            </Collapse.Panel>
            {ListData.filter(
              (_, index) => index && index < ListData.length - 1
            ).map((item, index) => {
              return (
                <Collapse.Panel header={item.title} key={index + 1}>
                  {item.details.map((secItem) => {
                    return (
                      <div
                        className={styles.pannelItem}
                        key={secItem.textHeader}
                      >
                        <img src={secItem.leftIcon} alt="" />
                        <div className={styles.textHeader}>
                          {secItem.textHeader}
                        </div>
                        <div className={styles.textNormal}>
                          {secItem.textNormal}
                        </div>
                      </div>
                    );
                  })}
                </Collapse.Panel>
              );
            })}
            <Collapse.Panel
              header={ListData[ListData.length - 1].title}
              key={ListData.length - 1}
            >
              <table className={styles.smallTableContainer}>
                <thead>
                  <tr>
                    <th>{t("featurePage.tableHeaders.0")}</th>
                    <th>{t("featurePage.tableHeaders.1")}</th>
                    <th className={styles.tdSpecial}>
                      <div
                        className={styles.tdInnerBox}
                        style={{ border: "none" }}
                      >
                        {t("featurePage.tableHeaders.2")}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((item) => {
                    return (
                      <tr key={item.name}>
                        <td>{item.name}</td>
                        <td>{item.intro}</td>
                        <td className={styles.tdSpecial}>
                          {item.details.map((item) => (
                            <div className={styles.tdInnerBox} key={item}>
                              {item}
                            </div>
                          ))}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Collapse.Panel>
          </Collapse>
        </Col>
      </Row>

      <Footer />
    </div>
  );
};

export default FeaturePage;
